import { getWhisper } from './whisperApi';

/**
 * Executes a function only when Whisper debug mode is enabled
 * @param fn - The function to execute in debug mode
 * @returns The result of the function if debug mode is enabled, undefined otherwise
 */
export const whenDebug = <T>(fn: () => T): T | undefined => {
  const whisper = getWhisper();
  if (whisper?.isDebugMode?.()) {
    return fn();
  }
};
